import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux';
import { loaderActions } from '../../../../../../_actions/loader.actions';
import { postUsersData, verifytoken } from '../../../../../../services/ApiCallingUserServices';
import { ClearLocalStorage } from '../../../../../commonClass/Session';
import { onlyNumeric } from '../../../../../commonClass/CommonValidation';
import { Autocomplete, FormControl, TextField } from '@mui/material';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Select from 'react-select';

function formatDate(date) {
    var d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = '' + d.getFullYear()

    if (month.length < 2)
        month = '0' + month;
    if (day.length < 2)
        day = '0' + day;

    return date === null ? "" : [day, month, year].join('/');
}

function formFormatDate(date) {
    var d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();

    if (month.length < 2)
        month = '0' + month;
    if (day.length < 2)
        day = '0' + day;

    return date === '' ? '' : [year, month, day].join('-');
}
const ActivityBlackoutModal = (props) => {
    const { title,
        isEdit,
        selectedCellDate,
        availabilityDates,
        setOpenModal,
        dayRangeList,
        ActivityBasicInfoId,
        UserId,
        ActivityName
    } = props;
    const dispatch = useDispatch();
    const [isSave, setIsSave] = useState(true);
    const [apiError, setApiError] = useState('');

    const [dateRangeValue, setDateRangeValue] = useState('');
    const [closedMessage, setClosedMessage] = useState('')

    useEffect(() => {
        if (selectedCellDate !== null) {
            setDateRangeValue(`${formatDate(new Date(selectedCellDate))}`)
        }
    }, [selectedCellDate])

    const [formValue, setFormValue] = useState({
        ActivityBasicInfoId: ActivityBasicInfoId,
        UserId: UserId,
        FromDateSelect: selectedCellDate || null,
        ToDateSelect: selectedCellDate || null,
        MealType: 0,
        FromDate: formFormatDate(selectedCellDate) + 'T:00:00:00' || null,
        ToDate: formFormatDate(selectedCellDate) + 'T:00:00:00' || null,
        Adult1: "",
        Adult2: "",
        Days: "",
    });
    const [formError, setFormError] = useState({})

    const onChange = (name, value) => {
        setFormError({});
        setIsSave(false);
        setFormValue(form => ({ ...form, [name]: value }))
    }

    const handleDateRange = (update) => {
        setFormError({});
        setIsSave(false);
        setFormValue(form => ({
            ...form,
            FromDate: formFormatDate(update[0]),
            FromDateSelect: update[0],
            ToDate: formFormatDate(update[1]),
            ToDateSelect: update[1],
        }))
        setDateRangeValue(`${formatDate(update[0])} - ${formatDate(update[1])}`);
    }

    const openDatePicker = (e) => {
        //open date picker on click date icon 
        document.querySelector("#" + e).click();
    };

    const onClose = () => {
        isSave ? setOpenModal(false) : setClosedMessage(true);
    }

    const YesProceed = (e) => {
        e.preventDefault()
        setOpenModal(false)
        setClosedMessage(false)
    }

    const NoProceed = (e) => {
        e.preventDefault()
        setClosedMessage(false)
    }

    const validateData = () => {
        let status = true;
        let error = {};

        if (formValue?.FromDateSelect === null || formValue?.ToDateSelect === null) {
            error["date"] = "Cannot leave blank. Input is mandatory.";
            status = false;
        }
        if (formValue?.MealType === 0) {
            error["MealType"] = "Cannot leave blank. Input is mandatory.";
            status = false;
        }
        if (formValue?.Days <= 0) {
            error["Days"] = "Cannot leave blank. Input is mandatory.";
            status = false;
        }
        if (!formValue?.Adult1 || formValue?.Adult1 === 0) {
            error["Adult1"] = "Cannot leave blank. Input is mandatory.";
            status = false;
        }
        if (!formValue?.Adult2 || formValue?.Adult2 === 0) {
            error["Adult2"] = "Cannot leave blank. Input is mandatory.";
            status = false;
        }
        if (!formValue?.ChildWithOutBed || formValue?.ChildWithOutBed === 0) {
            error["ChildWithOutBed"] = "Cannot leave blank. Input is mandatory.";
            status = false;
        }
        setFormError(error)

        return status;
    }

    const handleApply = async (e) => {
        e.preventDefault();
        if (validateData()) {
            dispatch(loaderActions.start());
            let statusoftoken = await verifytoken();
            if (statusoftoken) {
                const blackout = await postUsersData('/master/v1/InsertBulkUpdateInventoryRates', {
                    HotelBasicId: formValue?.HotelBasicId,
                    HotelRoomId: formValue?.RoomType,
                    DayRangesId: formValue?.Days,
                    FromDate: formValue?.FromDate,
                    ToDate: formValue?.ToDate,
                    UserId: formValue?.UserId,
                    RatesCollection: [
                        {
                            RateTypeId: formValue?.MealType,
                            Adults1: formValue?.Adult1 === "" ? 0 : formValue?.Adult1,
                            Adults2: formValue?.Adult2 === "" ? 0 : formValue?.Adult2,
                            AdultWithBed: formValue?.ExtraAdultWithBed === "" ? 0 : formValue?.ExtraAdultWithBed,
                            ChildWithBed: formValue?.ChildWithBed === "" ? 0 : formValue?.ChildWithBed,
                            ChildWithoutBed: formValue?.ChildWithOutBed === "" ? 0 : formValue?.ChildWithOutBed,
                            IsBlackOut: true
                        }
                    ]
                });

                if (blackout.status) {
                    setOpenModal(false);
                    setFormError({});
                    setIsSave(true);
                    dispatch({ type: 'ALERTING', message: blackout.message });
                    // dispatch(hotelRateInventoryOpen());
                    dispatch(loaderActions.end());
                    sessionStorage.setItem('latestStep', sessionStorage?.getItem('latestStep') >= "5" ? Number(sessionStorage?.getItem('latestStep')) : 5);
                } else {
                    setApiError(blackout.message)
                    dispatch(loaderActions.end());
                }
            }
            else {
                ClearLocalStorage();
                dispatch({ type: 'SESSIONOUT', message: 'Your Session Expired. Please Login Again!' });
                dispatch(loaderActions.end());
            }
        }
    }

    return (
        <>
            <div className="d-flex justify-content-between align-items-center bulk_update_modal_header">
                <div className="bulk_update_modal_title">
                    {title}
                </div>
                <div role='button' onClick={onClose}>
                    <i class="fa-solid fa-xmark"></i>
                </div>
            </div>

            {closedMessage &&
                <div className="text-center pb-3">
                    <span className="text-danger">Unsaved data, do you want to close the window ? </span>
                    <span role='button' style={{ color: '#0777A9' }} onClick={(e) => YesProceed(e)} > Yes </span>
                    or
                    <span role='button' style={{ color: '#0777A9' }} onClick={(e) => NoProceed(e)} > No</span>.
                </div>
            }
            <form action="" className='py-2'>
                {apiError && <span className='text-danger text-center mt-2'>{apiError}</span>}
                <div className='row'>
                    <div className="col-12 mb-4">
                        <input
                            type='text'
                            className='form-control'
                            name='InventoryStock'
                            id="available-quantity"
                            value={ActivityName}
                            readOnly
                        />
                    </div>
                    <div className="col-12 mb-4">
                        <div className="row">
                            <div className={`${isEdit ? 'col-12' : 'col-6'} `}>
                                <>
                                    <div className='position-relative'>
                                        <DatePicker
                                            dateFormat="dd/MM/yyyy"
                                            className='form-control'
                                            id='select-date'
                                            selected={formValue?.FromDateSelect}
                                            placeholderText="Select Date Range"
                                            selectsRange={true}
                                            autoComplete='off'
                                            showMonthDropdown
                                            startDate={formValue?.FromDateSelect}
                                            endDate={formValue?.ToDateSelect}
                                            onChange={(e) => handleDateRange(e, isEdit)}
                                            minDate={new Date() < new Date(availabilityDates?.StartDate) ? new Date(availabilityDates?.StartDate) : new Date()}
                                            maxDate={new Date(availabilityDates?.EndDate)}
                                        />
                                        <span className={`example-custom-input activityinventoryBtn ${selectedCellDate !== null ? 'disableCalBtn' : ''}`}
                                            onClick={(e) => openDatePicker("select-date")}
                                        ><i className="fa fa-calendar"></i></span>
                                    </div>
                                    {formError?.date && <small className='text-danger text-center mt-2'>{formError?.date}</small>}
                                </>
                            </div>
                                <div className="col-6">
                                    <Select
                                        name='Days'
                                        className="dropdown select_dropdown"
                                        options={dayRangeList}
                                        inputId='select-days'
                                        value={dayRangeList?.find((obj) => obj?.value === formValue?.Days) || null}
                                        onChange={(e) => onChange("Days", e?.value ? e?.value : null)}
                                        isSearchable
                                        placeholder='Days'
                                    />
                                    {formError?.Days && <small className='text-danger text-center mt-2'>{formError?.Days}</small>}
                                </div>
                        </div>
                    </div>
                    <div className="bulk_update_modal_title mb-2    ">
                        Special Rates
                    </div>

                    {/* <div className="col-12 mb-4">
                        <div className="row">
                            <div className="col-6">
                                <TextField
                                    fullWidth
                                    id="price-for-1-adult"
                                    label="Price for 1 Adults"
                                    name='Adult1'
                                    value={formValue?.Adult1 || ''}
                                    onChange={(e) => onChange(e.target.name, e.target.value === "" ? null : Number(onlyNumeric(e.target.value)))}
                                    className={`${formValue?.Adult1 === "" || formValue?.Adult1 === 0 ? 'red_border' : ''}`}
                                    error={formError?.Adult1 ? true : false}
                                    helperText={formError?.Adult1}
                                    inputProps={{ maxLength: 6 }}
                                    autoComplete='off'
                                    disabled={formValue?.MealType <= 0}
                                />
                            </div>
                            <div className="col-6">
                                <TextField
                                    fullWidth
                                    id="price-for-2-adult"
                                    label="Price for 2 Adults"
                                    name='Adult2'
                                    value={formValue?.Adult2 || ''}
                                    onChange={(e) => onChange(e.target.name, e.target.value === "" ? null : Number(onlyNumeric(e.target.value)))}
                                    className={`${formValue?.Adult2 === "" || formValue?.Adult2 === 0 ? 'red_border' : ''}`}
                                    error={formError?.Adult2 ? true : false}
                                    helperText={formError?.Adult2}
                                    inputProps={{ maxLength: 6 }}
                                    autoComplete='off'
                                    disabled={formValue?.MealType <= 0}
                                />
                            </div>
                        </div>
                    </div>

                    <div className="col-12 mb-4">
                        <div className="row">
                            <div className={`${ExtraBeddingAllowed ? 'col-6' : 'col-12'} `}>
                                <TextField
                                    fullWidth
                                    id="price-for-child-without-bed"
                                    label="Extra Child without bed / mattress"
                                    name='ChildWithOutBed'
                                    value={formValue.ChildWithOutBed}
                                    onChange={(e) => onChange(e.target.name, e.target.value === "" ? null : Number(onlyNumeric(e.target.value)))}
                                    className={`${formValue?.ChildWithOutBed === "" || formValue?.ChildWithOutBed === 0 ? 'red_border' : ''}`}
                                    error={formError?.ChildWithOutBed ? true : false}
                                    helperText={formError?.ChildWithOutBed}
                                    inputProps={{ maxLength: 6 }}
                                    autoComplete='off'
                                    disabled={formValue?.MealType <= 0}
                                />
                            </div>
                        </div>
                    </div> */}

                    <div className="col-12">
                        <button type="button" className='btn bulk_apply_btn btn-primary w-100' onClick={(e) => handleApply(e)}>Apply</button>
                    </div>
                </div>
            </form>

        </>
    )
}

export default ActivityBlackoutModal